import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import './advancedTab.css';

function ToggleMes({handleMesTypeButtonClick, selectedMesTypeButton, measurementSystem}){

    return(

        <div className='typeControlButton'>
        <ButtonGroup className="mb-2 toggleGroup">
            <ToggleButton
            id="toggle-si"
            type="radio"
            variant="secondary"
            name="measurement-system"
            value="SI"
            checked={selectedMesTypeButton === 'SI'}
            onChange={() => handleMesTypeButtonClick('SI')}
            className={`${selectedMesTypeButton === 'SI' ? 'typeActive' : 'typeInactive'} tog1`}

            >
            SI
            </ToggleButton>
            <ToggleButton
            id="toggle-imperial"
            type="radio"
            variant="secondary"
            name="measurement-system"
            value="Imperial"
            checked={selectedMesTypeButton === 'Imperial'}
            onChange={() => handleMesTypeButtonClick('Imperial')}
            className={`${selectedMesTypeButton === 'Imperial' ? 'typeActive' : 'typeInactive'} tog2`}
            >
            Imperial
            </ToggleButton>
        </ButtonGroup>
        </div>

    )


}

export default ToggleMes;
